import Vue from 'vue'
import Vuex from 'vuex'

import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import users from '@/store/user-management'
import contacts from './contacts/index'
import materials from '@/store/reference/materials'
import characterUnits from '@/store/reference/characterUnits'
import instruments from '@/store/reference/instruments'
import obectsWarehouse from '@/store/reference/obectsWarehouse'
import moneyReport from '@/store/reference/moneyReport'
import brigade from '@/store/reference/brigade'
import brigadeWorks from '@/store/reference/brigadeWorks'
import transport from '@/store/reference/transport'
import placeOfWork from '@/store/reference/placeOfWork'
import role from '@/store/role'
import taskManager from '@/store/taskManager'
import application from '@/store/application'
import agrements from '@/store/agrements'
import storage from '@/store/storage'
import content from './content'
import pto from './pto'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    users,
    contacts,
    materials,
    characterUnits,
    instruments,
    obectsWarehouse,
    role,
    moneyReport,
    taskManager,
    application,
    agrements,
    storage,
    content,
    pto,
    brigade,
    brigadeWorks,
    transport,
    placeOfWork,
  },
  strict: process.env.DEV,
})
